import { AmplitudeExperiments, AmplitudeVariants } from '@/utils/amplitude/experiments/AmplitudeExperiments';
import { useAmplitudeExperimentBase } from '@/utils/amplitude/experiments/utils/useAmplitudeExperimentBase';

export const useCookiebotUiRedesignExperiment = () =>
    useAmplitudeExperimentBase(
        AmplitudeExperiments.CookiebotUiRedesign,
        AmplitudeVariants.CookiebotUiRedesign.Treatment
    );
